<template>
  <div>
    <h3>Facturar a :</h3>

    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          type="text"
          v-model="nombreCliente"
          :rules="textRules"
          label="Nombre del cliente"
          required
          outlined
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          type="text"
          v-model="emailCliente"
          :rules="textRules"
          label="Correo del cliente"
          required
          outlined
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          type="text"
          v-model="direccionCliente"
          :rules="textRules"
          label="Direccion del cliente"
          required
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          type="text"
          v-model="telefonoCliente"
          :rules="textRules"
          label="Telefono del cliente"
          required
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState,mapActions } from "vuex";

export default {
  name: "Datoscliente",
  data() {
    return {
      nombreCliente: "",
      telefonoCliente: "",
      emailCliente: "",
      direccionCliente: ""
    };
  },
  methods:{
    ...mapActions(["cargarEmailCliente","cargarDireccionCliente","cargarTelefonoCliente","cargarNombreCliente"])
  },
  computed: {
    ...mapState(["numberRules", "textRules"])
  },
  watch: {
    nombreCliente: function(newValue) {
      this.cargarNombreCliente(newValue);
    },
    telefonoCliente: function(newValue) {
      this.cargarTelefonoCliente(newValue);
    },
    emailCliente: function(newValue) {
      this.cargarEmailCliente(newValue);
    },
    direccionCliente: function(newValue) {
      this.cargarDireccionCliente(newValue);
    }
  }
};
</script>